import { Outlet, Link } from "react-router-dom";
import { StoreHeader } from "@/components/store/StoreHeader";
import { CartSheet } from "@/components/store/CartSheet";
import { useStore } from "@/context/StoreContext";

export default function StoreLayout() {
  const { settings } = useStore();
  return (
    <div className="min-h-screen bg-[#0B0F19] text-slate-100 flex flex-col">
      {settings?.announcement && (
        <div className="bg-violet-600 text-white text-xs sm:text-sm text-center py-2 px-4 font-medium" data-testid="store-announcement">
          {settings.announcement}
        </div>
      )}
      <StoreHeader />
      <main className="flex-1"><Outlet /></main>
      <CartSheet />
      <footer className="border-t border-white/10 mt-24" data-testid="store-footer">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-10 flex flex-col sm:flex-row gap-4 justify-between text-sm text-slate-400">
          <div>
            <p className="font-heading font-bold text-slate-200">{settings?.store_name || "Loja GugMC"}</p>
            {settings?.contact && <p className="mt-1">{settings.contact}</p>}
          </div>
          <div className="flex items-center gap-4">
            <span className="px-2 py-1 rounded border border-emerald-500/30 text-emerald-300 text-xs font-mono">PIX</span>
            <span className="px-2 py-1 rounded border border-rose-500/30 text-rose-300 text-xs font-mono">MB WAY</span>
            <Link to="/admin" className="text-slate-500 hover:text-slate-200 transition-colors" data-testid="footer-admin-link">Painel</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
